// アンケートの点数は 5＝大変満足 で送る（2026-11-02 坂田社長・マンションの★と同じ向き）。
// 画面の並びは「大変満足」が先のまま。API は scale=best5 が付いていない回答を古い向き（1＝大変満足）として直す。
export const SURVEY_SCALE = 'best5';
export const surveyValue = (i) => 5 - i;
